import React from 'react';
import { Typography } from '@mui/material';
import { QualificationTitleRender } from '../../lib/CommonComponents';
import { useRecordContext } from 'react-admin';

export const QualificationTitle = () => {
    const record = useRecordContext();
    let qualId = "";
    let canRender = false;
   
        if(record?.exitPoints?.length > 0){
            canRender = true;
            var finalExitPoint = record.exitPoints.find(obj => {
                return obj.intermediateOrFinal == "Final"
            });
            
            if(finalExitPoint == undefined){
                canRender = false;
            }
            else{
                qualId = finalExitPoint.qualificationId;
            }
        }

    return canRender? (
        <QualificationTitleRender
            record={record}
            qualificationId={qualId}
        />
    ) : (
        <>
        <Typography>
            {record?.Title}
            <small  style={{color: "#bfbfbf", display: "block"}}>
            v{record?.version} - Valid from {new Date(record?.validationFrom).toLocaleDateString('en-gb', { day: "numeric", year:"numeric", month:"short"})} to {new Date(record?.validationTo).toLocaleDateString('en-gb', { day: "numeric", year:"numeric", month:"short"})}
            </small>
        </Typography>
        </>
    );
};

function findArrayElementByTitle(array, title) {
    return array.find((element) => {
      return element.title === title;
    })
  }
